export const nb = (n) => new Intl.NumberFormat("nb-NO").format(n ?? 0);

export const nok = (n) =>
  new Intl.NumberFormat("nb-NO", { style: "currency", currency: "NOK", maximumFractionDigits: 0 }).format(n ?? 0);

export function formatDate(d) {
  if (!d) return "–";
  try {
    return new Date(d).toLocaleDateString("nb-NO", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
}

export function formatDateTime(d) {
  if (!d) return "–";
  try {
    return new Date(d).toLocaleString("nb-NO", {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return d;
  }
}

export function fileSize(bytes) {
  if (!bytes) return "–";
  const units = ["B", "KB", "MB", "GB"];
  let i = 0;
  let n = bytes;
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i++;
  }
  return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}

export const MEETING_TYPE = {
  styremote: "Styremøte",
  generalforsamling: "Generalforsamling",
  ekstraordinar_gf: "Ekstraordinær generalforsamling",
};

export function meetingTypeLabel(t) {
  return MEETING_TYPE[t] || "Møte";
}
